import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Enter your email");
    setSubmitting(true);
    try {
      const res = await fetch(`${BACKEND}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), name: name.trim() || null }),
      });
      if (res.ok) {
        setDone(true);
        toast.success("You're on the list — thanks for tuning in.");
        setEmail("");
        setName("");
      } else {
        const j = await res.json().catch(() => ({}));
        toast.error(j.detail || "Something went wrong");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="newsletter-thankyou"
        className="rounded-lg border border-gold/40 bg-jet-surface/70 p-5 flex items-center gap-3"
      >
        <div className="w-9 h-9 grid place-items-center rounded-full bg-gold/20 text-gold">
          <Check className="w-4 h-4" />
        </div>
        <div>
          <div className="font-condensed uppercase tracking-widest text-[11px] text-gold">
            Subscribed
          </div>
          <div className="font-body text-sm text-white">
            You'll hear from the booth when a show drops.
          </div>
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className="rounded-lg border border-gold/25 bg-jet-surface/60 p-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-4 h-4 text-gold" />
        <div>
          <div className="font-condensed uppercase tracking-[0.35em] text-[10px] text-gold">
            Newsletter
          </div>
          <div className="font-display text-lg text-white uppercase leading-none">
            Show alerts & event drops
          </div>
        </div>
      </div>
      <div className="grid sm:grid-cols-[1fr_1.5fr_auto] gap-2">
        <input
          data-testid="newsletter-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="First name (optional)"
          maxLength={64}
          className="bg-neutral-900 border border-neutral-800 focus:border-gold rounded-md px-3 py-2 text-sm text-white outline-none"
        />
        <input
          data-testid="newsletter-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          maxLength={200}
          className="bg-neutral-900 border border-neutral-800 focus:border-gold rounded-md px-3 py-2 text-sm text-white outline-none"
        />
        <button
          data-testid="newsletter-submit"
          type="submit"
          disabled={submitting}
          className="bg-gold hover:bg-gold-light disabled:opacity-50 text-black font-condensed uppercase tracking-widest text-xs px-5 py-2 rounded-md transition-colors whitespace-nowrap"
        >
          {submitting ? "Sending…" : "Sign Up"}
        </button>
      </div>
      <p className="mt-2 font-body text-[11px] text-neutral-500">
        Occasional show-drops, no spam. Unsubscribe anytime.
      </p>
    </form>
  );
};

export default NewsletterSignup;
